import React from "react";
import { styled, Typography } from "@material-ui/core";

const CustomHeading = styled(({ children, ...props }) => (
  <Typography component="h1" {...props}>
    {children}
  </Typography>
))(({ theme }) => ({
  fontFamily: "Reckless, Georgia",
  letterSpacing: 0,
  fontSize: "3.0rem",
  lineHeight: "3.2rem",
  [theme.breakpoints.up("md")]: {
    fontSize: "4.0rem",
    lineHeight: "4.2rem"
  }
}));

export default CustomHeading;
